<template>
  <div>
    <!-- <Header :hasMenu="true"></Header> -->
    <Header v-if="!$isOptimize && !$isMida"></Header>
    <SettingMenu></SettingMenu>
    <div class="page-wrapper-2">
      <div style="margin-top: 56px">
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
import Header from '@/components/Header.vue'
import SideMenu from '@/layouts/menus/SideMenu.vue'
import ApplicationMenu from '@/layouts/menus/ApplicationMenu.vue'
import ReportMenu from '@/layouts/menus/ReportMenu.vue'
import SettingMenu from '@/layouts/menus/SettingMenu.vue'
import Footer from '@/components/Footer.vue'

var axios = require('axios')

export default {
  components: {
    Header,
    SideMenu,
    ApplicationMenu,
    ReportMenu,
    SettingMenu,
    Footer,
  },
  mounted() {
    console.log('AuthMenu')
    if (this.$session.exists()) {
      // this one should keep as axios otherwise $http.post will kick user logout when route changes
      setTimeout(() => {
        axios.post(process.env.API_ENDPOINT + '/ping')
          .then()
          .catch((err) => {
            this.$swal.fire(
              'Oppss..',
              'Your session has expired. Please login again.',
              'warning'
            )
            this.$router.push({ path: '/logout' })
          })
        }, 10000)

        this.$http.get(process.env.API_ENDPOINT + '/user').then((result) => {
        if (result.data.length && !this.$session.get('bypass')) {
          this.$session.set('role', result.data[0].role)
          this.$session.set('paid_plan', result.data[0].paid_plan)
          if (result.data[0].status !== 1) {
            this.$router.push({ path: '/logout' })
          }
        }
      })

      if (
        this.$session.get('isAuth0') &&
        (!this.$auth.isAuthenticated ||
          this.$auth.user.email !== this.$session.get('email'))
      ) {
        // check if auth0 session still available
        this.$router.push({ path: '/logout' })
      }
    }
  },
}
</script>
<style>
.page-wrapper-2 {
  margin-left: var(--sidebar-width); /* menubar width */
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;  
}
</style>



// WEBPACK FOOTER //
// src/layouts/AuthMenu.vue